import { HTTP } from '../../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { Company } from '../../../models/Company';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';

export const { mapFields: mapCompanyFields } = createHelpers({
  getterType: `company/getField`,
  mutationType: `company/updateField`,
});

const state = {
  company: new Company(),
  message: new httpError(),
};

//getters

const getters = {
  soletrader(state) {
    if (state.company.entityType != null) {
      if (
        state.company.entityType.includes('T') ||
        state.company.entityType === 'IND' ||
        state.company.entityType === 'LGL'
      )
        return true;
      else return false;
    }
  },
  monthsOld(state) {
    if (state.company.abn_status_from_date) {
      let fromDate = new Date(state.company.abn_status_from_date);
      let toDate = new Date();
      let months = (toDate.getFullYear() - fromDate.getFullYear()) * 12;
      months += toDate.getMonth() - fromDate.getMonth();
      return months;
    } else return 0;
  },
  getField,
  company(state) {
    return state.company;
  },
};

//Mutations
const mutations = {
  setCompany(state, company) {
    state.company = company;
  },
  setProgress(state, message) {
    state.message = message;
  },
  updateField,
};

//ACTIONS
const actions = {
  resetCompany({ commit }) {
    commit('setCompany', new Company());
    commit('setProgress', new httpError());
  },
  getCompany({ commit, dispatch }, companyID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/getCompany/' + companyID);
      response
        .then(function (data) {
          var resultData = data.data;
          if (resultData) {
            resultData.industry = 'Q';
            resultData.subIndustry = 'QA';
          }

          commit('setCompany', resultData);
          commit('orders/setResidential', false, { root: true });
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 200,
              message: 'Retreived OK',
            })
          );
          resolve(resultData);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 500,
              message: 'Error Retreiving:' + err.message,
            })
          );
          reject(err.message);
        });
    });
  },
  addCompany({ state, commit, dispatch, rootState }) {
    if (state.company.abn_status_from_date == null) {
      const formattedDate = new Date().toISOString().split('T')[0];
      state.company.abn_status_from_date = formattedDate;
    }

    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/AddCompany', state.company);
      response
        .then(function (data) {
          var resultData = data.data;
          commit('setCompany', resultData);
          HTTP.post(
            `order/AddCompanyToOrder/${rootState.orders.rows[0].orderID}`,
            resultData
          ).then(() => {
            dispatch(
              'setMessage',
              new httpError({
                httpStatus: 200,
                message: 'Company added OK',
              })
            );
            resolve(resultData);
          });
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 500,
              message: 'Error Adding:' + err,
            })
          );
          reject(err);
        });
    });
  },
  async updateCompany({ state, commit, dispatch, rootState }) {
    var response = HTTP.put(
      `Order/updateCompany/${rootState.orders.rows[0].orderID}`,
      state.company
    );
    response
      .then(function (data) {
        var resultData = data.data;
        commit('setCompany', resultData);
        dispatch(
          'setMessage',
          new httpError({
            httpStatus: 200,
            message: 'Updated OK',
          })
        );
        return Promise.resolve(resultData);
      })
      .catch((err) => {
        dispatch('setMessage', 'Error updating company :' + err);
        return Promise.reject(err);
      });
  },
  getDataFromACN({ dispatch }, abn) {
    return new Promise((resolve, reject) => {
      HTTP.get('TotalCheck/ValidateABN/' + abn)
        .then((data) => {
          if (data.status == 200) {
            var response = data.data;
            if (response.result_count > 0) {
              var result = response.results[0];
              var companyResult = new Company();
              companyResult.otherOrganisation = false;
              companyResult.companyName = result.entity_name;
              companyResult.abn_status_from_date = result.abn_status_from_date;
              if (result.other_names !== null) {
                if (!state.company.isUpdatedTradingName) {
                  companyResult.tradingName =
                    result.other_names[
                      result.other_names.length - 1
                    ].other_name;
                }
                companyResult.entityType =
                  result.entity_type_code || result.entity_name_type;
              } else {
                companyResult.companyName = result.entity_name;
                companyResult.entityType = result.entity_type_code;
              }
              if (
                !(
                  companyResult.entityType.includes('T') ||
                  companyResult.entityType === 'IND'
                )
              ) {
                companyResult.abn = result.abn;
                companyResult.acn = result.acn || result.abn;
                if (!state.company.isUpdatedTradingName) {
                  companyResult.tradingName = result.entity_name;
                }
                companyResult.isdirectorSurnameRequired = false;
                companyResult.isdateOfBirthRequired = false;
                companyResult.otherOrganisation = false;
              } else {
                companyResult.otherOrganisation = true;
                companyResult.abn = result.abn;
                companyResult.acn = result.acn || result.abn;
                companyResult.companyName = result.entity_name;
                if (!state.company.isUpdatedTradingName) {
                  if (result.other_names !== null) {
                    companyResult.tradingName =
                      result.other_names[0].other_name;
                  } else {
                    companyResult.tradingName = result.entity_name;
                  }
                }
                companyResult.isdirectorSurnameRequired = true;
                companyResult.isdateOfBirthRequired = true;
                companyResult.otherOrganisation = true;
              }
              resolve(companyResult);
            } else reject('No ABN Provided');
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in getting : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  validateACN({ state, commit, dispatch }, _abn) {
    return new Promise((resolve, reject) => {
      try {
        commit('setProgress', new httpError());
        if (
          !_abn &&
          (!state.company ||
            !state.company.abn ||
            state.company.abn.length == 0)
        )
          resolve('No ABN Provided');
        let abn = `${abn || state.company.abn}`.replace(/\s+/g, '');
        if (abn) {
          HTTP.get('TotalCheck/ValidateABN/' + abn)
            .then((result) => {
              var data = result.data;
              if (data.result_count > 0) {
                let result = data.results[0];
                let companyResult = { ...state.company };
                // Object.assign(companyResult, state.company);
                companyResult.otherOrganisation = false;
                companyResult.companyName = result.entity_name;
                companyResult.abn_status_from_date =
                  result.abn_status_from_date;
                if (
                  result.other_names !== null &&
                  !state.company.isUpdatedTradingName
                ) {
                  companyResult.tradingName =
                    result.other_names[
                      result.other_names.length - 1
                    ].other_name;
                  companyResult.entityType =
                    result.entity_type_code || result.entity_name_type;
                } else {
                  companyResult.companyName = result.entity_name;
                  companyResult.entityType = result.entity_type_code;
                }
                if (
                  !(
                    companyResult.entityType.includes('T') ||
                    companyResult.entityType === 'IND'
                  )
                ) {
                  companyResult.abn = result.abn;
                  companyResult.acn = result.acn || result.abn;
                  if (!state.company.isUpdatedTradingName) {
                    companyResult.tradingName = result.entity_name;
                  }
                  companyResult.isdirectorSurnameRequired = false;
                  companyResult.isdateOfBirthRequired = false;
                  companyResult.otherOrganisation = false;
                } else {
                  companyResult.otherOrganisation = true;
                  companyResult.abn = result.abn;
                  companyResult.acn = result.acn || result.abn;
                  companyResult.companyName = result.entity_name;
                  if (!state.company.isUpdatedTradingName) {
                    if (result.other_names !== null) {
                      companyResult.tradingName =
                        result.other_names[0].other_name;
                    } else {
                      companyResult.tradingName = result.entity_name;
                    }
                  }
                  companyResult.isdirectorSurnameRequired = true;
                  companyResult.isdateOfBirthRequired = true;
                  companyResult.otherOrganisation = true;
                }
                companyResult.abnLookupResponse = data.results[0];
                commit('setCompany', companyResult);

                dispatch(
                  'setMessage',
                  new httpError({
                    message: 'Company retreived OK',
                    httpStatus: 200,
                  })
                );
                resolve(companyResult);
              } else reject('No ABN Provided');
            })
            .catch((err) => {
              if (
                err.response.request.response == '' ||
                err.response.request.response == null
              ) {
                dispatch(
                  'setMessage',
                  new httpError({
                    message: 'Internal Server Error from 3rd-Party API',
                    httpStatus: 500,
                  })
                );
              } else {
                dispatch(
                  'setMessage',
                  new httpError({
                    message: 'Company Error:' + err,
                    httpStatus: 500,
                  })
                );

                dispatch(
                  'setMessage',
                  new httpError({
                    message: 'ABN is for an existing customer!',
                    httpStatus: 409,
                  })
                );
              }
              reject(err);
            });
        } else reject('No ABN Provided');
      } catch (error) {
        reject(error);
      }
    });
  },
  saveCompanyName({ state, commit }) {
    var companyResult = { ...state.company };
    companyResult.otherOrganisation = false;
    companyResult.isdirectorSurnameRequired = false;
    companyResult.isdateOfBirthRequired = false;
    commit('setCompany', companyResult);
    return state.company;
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
